// extracted by mini-css-extract-plugin
module.exports = {"panelBody":"styles__panelBody___1Px-D","panel":"styles__panel___2H-tz","noRecords":"styles__noRecords___2x9-k","hidden":"styles__hidden___2YWoi"};